import { render, staticRenderFns } from "./CancelFriend.vue?vue&type=template&id=6742cd30"
import script from "./CancelFriend.vue?vue&type=script&lang=js"
export * from "./CancelFriend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports